import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import reduxUtils from 'util/redux';
import classnames from 'classnames';
import facetMap from 'util/react/facet';
import { connect } from 'react-redux';
import looppa from 'looppa';
import { CARD } from 'constants/placeholder-events';
import Plugin from '../plugin';

class ColumnWrapper extends PureComponent {
    static propTypes = {
        plugins: PropTypes.array,
        style: PropTypes.string,
        isCmsEditModeEnabled: PropTypes.bool,
        type: PropTypes.string.isRequired,
        cms: PropTypes.array,
    };

    static defaultProps = {
        plugins: [],
    };

    state = {
        extendedContent: {},
    };

    onEvent = (eventName, data) => {
        if (eventName === CARD) {
            this.setState({ extendedContent: data });
        }
    };

    /**
     * Add custom data to plugins if so requested by one of the plugins
     * via onEvent
     */
    get extendedPlugins() {
        return this.props.plugins.map(plugin => {
            plugin.content = { ...plugin.content, ...this.state.extendedContent };
            return plugin;
        });
    }

    render() {
        const { style, isCmsEditModeEnabled } = this.props;

        return (
            <div className={classnames('cms-column-wrapper', facetMap(style, 'cms-column-wrapper'))}>
                <div className="cms-column-wrapper--row">
                    {looppa(this.extendedPlugins)((plugin, i) =>
                        <div key={i} className="cms-column-wrapper--col">
                            <Plugin
                                isCmsEditModeEnabled={isCmsEditModeEnabled}
                                index={i}
                                style={style}
                                onEvent={this.onEvent}
                                parent={this.props}
                                {...plugin}
                            />
                        </div>
                    )}
                </div>
            </div>
        );
    }
}

export default connect(
    reduxUtils.mapStateToProps({}),
    reduxUtils.mapDispatchToProps({}),
)(ColumnWrapper);



// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/components/cms-placeholder/column-wrapper/index.js